module.exports = __webpack_public_path__ + "static/media/zind_rugarama7.6c3d02c5.jpg";